import { Popconfirm, Typography } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
const { Text } = Typography;

export const EMPLOYEE_COLUMNS_HEAD = (confirmDelete) => {
    return [
        {
            title: '',
            dataIndex: 'value',
            align: 'left',
            render: (ele) => {
                return <Text style={{ wordBreak: 'break-word' }}>{ele}</Text>
            }
        },
        {
            title: '',
            dataIndex: '',
            render: (ele) => {
                return <Popconfirm
                    placement="topRight"
                    title="Delete the Table"
                    description="Are you sure You want to delete this Table?"
                    onConfirm={() => confirmDelete(ele)}
                    okText="Yes"
                    cancelText="No"
                >
                    <DeleteOutlined style={{
                        backgroundColor: 'rgba(248, 70, 70, 0.15)',
                        color: '#F84646',
                        borderRadius: '3px',
                        padding: '6px',
                        fontSize: '16px',
                        cursor: 'pointer'
                    }} />
                </Popconfirm>
            },
        },
    ]
};